<template>
  <a-modal
    title="调整余额"
    :visible="visible"
    :confirm-loading="submitLoading"
    @ok="handleSubmit"
    @cancel="handleCancel"
    :mask-closable="false"
    width="500px"
  >
    <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
      <a-form-model-item label="用户信息">
        <a-input :value="userInfo" disabled />
      </a-form-model-item>
      <a-form-model-item label="调整金额" prop="money">
        <a-input-number
          v-model="form.money"
          placeholder="请输入调整金额，正数为增加，负数为减少"
          style="width: 100%"
          :precision="2"
          :min="-999999999"
          :max="999999999"
        />
        <div style="color: #999; font-size: 12px; margin-top: 4px">
          提示：正数表示增加余额，负数表示减少余额
        </div>
      </a-form-model-item>
      <a-form-model-item label="备注说明" prop="flowExplain">
        <a-textarea
          v-model="form.flowExplain"
          placeholder="请输入备注说明"
          :rows="3"
          :max-length="200"
          show-word-limit
        />
      </a-form-model-item>
    </a-form-model>
  </a-modal>
</template>

<script>
import { adjustBalance } from '@/api/pressure/fund'

export default {
  name: 'AdjustBalanceModal',
  data() {
    return {
      visible: false,
      submitLoading: false,
      userInfo: '',
      form: {
        userId: undefined,
        money: undefined,
        flowExplain: '',
      },
      rules: {
        money: [{ required: true, message: '请输入调整金额', trigger: 'blur' }],
        flowExplain: [{ required: true, message: '请输入备注说明', trigger: 'blur' }],
      },
    }
  },
  methods: {
    init(record) {
      this.visible = true
      this.userInfo = `${record.userName || ''} / ${record.userPhone || ''}`
      this.form = {
        userId: record.userId,
        money: undefined,
        flowExplain: '',
      }
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (!this.form.money || this.form.money === 0) {
            this.$message.warning('调整金额不能为0')
            return
          }
          this.submitLoading = true
          adjustBalance(this.form)
            .then((res) => {
              if (res.success) {
                this.$message.success('调整余额成功')
                this.handleCancel()
                this.$emit('success')
              } else {
                this.$message.error(res.message || '调整余额失败')
              }
            })
            .catch(() => {
              this.$message.error('调整余额失败')
            })
            .finally(() => {
              this.submitLoading = false
            })
        }
      })
    },
    handleCancel() {
      this.visible = false
      this.form = {
        userId: undefined,
        money: undefined,
        flowExplain: '',
      }
      this.userInfo = ''
      if (this.$refs.form) {
        this.$refs.form.clearValidate()
      }
    },
  },
}
</script>

<style lang="less" scoped>
</style>
